import {cloneDeep, isEmpty} from 'lodash'
import {yup} from 'libs/yup'

const hasCommuteSpanTypeSchema = (() => {
  const commutingExpenseSchema = yup.object({
    payment_duration_unit: yup.string().notRequired(),
  })
  return yup
    .object({
      commute_span_type: yup.string().notRequired(),
      commuting_expenses: yup
        .object({
          train: yup.array(commutingExpenseSchema).notRequired(),
          bus: yup.array(commutingExpenseSchema).notRequired(),
          car: commutingExpenseSchema.notRequired(),
        })
        .notRequired(),
    })
    .strict()
})()

const commuteSpanToPaymentDurationUnitMap: Record<string, string> = {
  month_1: 'per_month',
  month_3: 'per_3months',
  month_6: 'per_6months',
}

// https://github.com/d-o-n-u-t-s/roumu-server/issues/8588 支給単位に定期期間を入れる処理
const migrateCommuteSpanToPaymentDurationUnit = (tmpData: Record<string, unknown>): void => {
  if (!hasCommuteSpanTypeSchema.isValidSync(tmpData)) {
    return
  }

  const commuteSpanType = tmpData.commute_span_type
  if (!commuteSpanType) {
    return
  }

  tmpData.commuting_expenses?.train?.forEach((train) => {
    // 支給単位の上書き防止
    if (!train.payment_duration_unit) {
      train.payment_duration_unit = commuteSpanToPaymentDurationUnitMap[commuteSpanType]
    }
  })
  tmpData.commuting_expenses?.bus?.forEach((bus) => {
    if (!bus.payment_duration_unit) {
      bus.payment_duration_unit = commuteSpanToPaymentDurationUnitMap[commuteSpanType]
    }
  })
  // 通勤種別が車・二輪車等を含む場合の処理
  const car = tmpData.commuting_expenses?.car
  if (car) {
    if (!car.payment_duration_unit) {
      car.payment_duration_unit = commuteSpanToPaymentDurationUnitMap[commuteSpanType]
    }
  }
}

const hasCarCommutingDistanceTypeSchema = yup
  .object({
    commuting_expenses: yup
      .object({
        car: yup
          .object({
            car_commuting_distance_type: yup.string().notRequired(),
          })
          .required(),
      })
      .required(),
  })
  .strict()

// https://github.com/d-o-n-u-t-s/roumu-server/issues/11185 リリース以前の「片道の通勤距離: 55km以上」を「55km～65km」に変換
const migrateCarCommutingDistanceOver55 = (tmpData: Record<string, unknown>): void => {
  if (
    hasCarCommutingDistanceTypeSchema.isValidSync(tmpData) &&
    tmpData.commuting_expenses.car.car_commuting_distance_type === 'ds_over_55'
  ) {
    tmpData.commuting_expenses.car.car_commuting_distance_type = 'ds_55_65'
  }
}

export const migrateTmpData = (tmpData: Record<string, unknown>): Record<string, unknown> => {
  if (isEmpty(tmpData)) {
    return tmpData
  }
  const modifiedData = cloneDeep(tmpData)

  migrateCommuteSpanToPaymentDurationUnit(modifiedData)
  migrateCarCommutingDistanceOver55(modifiedData)

  return modifiedData
}
